import HomeHero from './components/HomeHero';
import CategoryNav from './components/CategoryNav';
import HotRecommendations from './components/HotRecommendations';
import LatestUpdates from './components/LatestUpdates';
import CompletedShows from './components/CompletedShows';
import HomeFeatures from './components/HomeFeatures';
import HomeFAQ from './components/HomeFAQ';
import CTA from './components/CTA';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '天堂影视 - 电视剧全集免费在线观看',
    description: '天堂影视电视剧全集免费在线观看，高清画质不缓冲不卡顿，提供最新热播剧全集资源，追剧党必备，剧集完结免广告，每日更新。',
    url: 'https://www.tiantangyingshi.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '天堂影视',
      url: 'https://www.tiantangyingshi.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <article>
        <HomeHero />
        <CategoryNav />
        <HotRecommendations />
        <LatestUpdates />
        <CompletedShows />
        <HomeFeatures />
        <CTA />
        <HomeFAQ />
      </article>
    </>
  );
}